import { __decorate } from 'tslib';
import { CommonModule } from '@angular/common';
import { EventEmitter, ViewChild, Input, Output, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA, ɵɵdefineInjectable, Injectable, ɵɵinject } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { SGWTConnectCore } from '@sgwt/connect-core';
import { CookieService } from 'ngx-cookie-service';
import { SGWTConnectCore as SGWTConnectCore$1 } from '@sgwt/connect-core/dist/src/SGWTConnectCore';
import { bindCallback } from 'rxjs';
import { mergeMap, filter, pluck, isEmpty, map, take, tap } from 'rxjs/operators';
import { SGWTConnectCore as SGWTConnectCore$2 } from '@sgwt/connect-angular';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-cookie-service';
import * as ɵngcc2 from '@sgwt/connect-core';
import * as ɵngcc3 from '@sgwt/connect-angular';

const _c0 = ["sgwtWidget"];
var SgsDatetimePickerComponent_1;
let SgsDatetimePickerComponent = SgsDatetimePickerComponent_1 = class SgsDatetimePickerComponent {
    // constructor and interfaces’ implementations
    constructor() {
        this.DEFAULT_KEYNAME = 'value';
        this._userSelection = {};
        this._keyName = this.DEFAULT_KEYNAME;
        this.pickerShown = false;
        this.ready = false;
        this.changeListeners = new Array();
        this.touchListeners = new Array();
        this.blur = new EventEmitter();
        window.SGSCustom = window.SGSCustom || {};
        window.SGSCustom.sgsDatetimeWidget = window.SGSCustom.sgsDatetimeWidget || { _sequence_next: 0 };
        this.id = window.SGSCustom.sgsDatetimeWidget._sequence_next++;
        this._userSelection['isValidDate'] = this.isValidDateFunctionPath();
        window.SGSCustom.sgsDatetimeWidget['component' + this.id] = {
            isValidDate: (moment) => this._isValidDate ? this._isValidDate(moment) : true
        };
    }
    // object public API
    set inputProps(value) {
        if (typeof value === 'string') {
            this._inputProps = value ? JSON.parse(value) : undefined;
        }
        else {
            this._inputProps = value;
        }
        this.updateInputProps();
    }
    set dateFormat(value) {
        this._userSelection['dateFormat'] = value || null;
        this.updateWidget();
    }
    set disabled(value) {
        let isDis;
        if (typeof value === 'boolean') {
            isDis = value;
        }
        else {
            isDis = value === 'true' || value === '';
        }
        this._userSelection['disabled'] = isDis || null;
        this.updateWidget();
    }
    set displayDateFormat(value) {
        this._userSelection['displayDateFormat'] = value || null;
        this.updateWidget();
    }
    set displayTimeFormat(value) {
        this._userSelection['displayTimeFormat'] = value || null;
        this.updateWidget();
    }
    set keyName(value) {
        this._keyName = value || this.DEFAULT_KEYNAME;
        this._userSelection['keyName'] = value || this.DEFAULT_KEYNAME;
        this.updateWidget();
    }
    set isValidDate(value) {
        this._isValidDate = value || undefined;
    }
    set label(value) {
        this._userSelection['label'] = value || null;
        this.updateWidget();
    }
    set returnEmpty(value) {
        if (typeof value === 'boolean') {
            this._userSelection['returnEmpty'] = value;
        }
        else {
            this._userSelection['returnEmpty'] = (value === 'true');
        }
        this._returnEmpty = this._userSelection['returnEmpty'];
        this.updateWidget();
    }
    set theme(value) {
        this._userSelection['theme'] = value || null;
        this.updateWidget();
    }
    set timeFormat(value) {
        this._userSelection['timeFormat'] = value || null;
        this.updateWidget();
    }
    set timeConstraints(value) {
        if (!value || typeof value === 'string') {
            this._userSelection['timeConstraints'] = value || null;
        }
        else {
            this._userSelection['timeConstraints'] = JSON.stringify(value);
        }
        this.updateWidget();
    }
    set type(value) {
        this._userSelection['type'] = value || null;
        if (value === 'time') {
            this._userSelection['viewMode'] = 'time';
        }
        this.updateWidget();
    }
    set value(value) {
        const doNotify = value !== this._dateValue;
        this._dateValue = value;
        this._userSelection['value'] = value ? value.toISOString() : null;
        this.updateWidget();
        if (doNotify) {
            this.notifyChangeListeners();
        }
    }
    set locale(value) {
        this._userSelection['locale'] = value || null;
        this.updateWidget();
    }
    set viewMode(value) {
        this._userSelection['viewMode'] = value || null;
        this.updateWidget();
    }
    set placeholder(value) {
        this._userSelection['placeholder'] = value || null;
        this.updateWidget();
    }
    set userSelection(value) {
        Object.keys(value).forEach(k => {
            if (typeof k === 'string') {
                let words = k.split('-');
                let widgetK = words[0];
                for (let i = 1; i < words.length; i++) {
                    widgetK += words[i].charAt(0).toUpperCase() + words[i].substr(1);
                }
                this._userSelection[widgetK] = value[k] || null;
            }
        });
        this.updateWidget();
    }
    get value() {
        return this.currentDate();
    }
    get userSelection() {
        const key = this._keyName || this.DEFAULT_KEYNAME;
        const value = this.currentDate();
        let result = {};
        if (value || !this._returnEmpty) {
            result[key] = value;
        }
        return result;
    }
    toggleCalendar() {
        this.pickerShown = !this.pickerShown;
        if (this.ready) {
            this.sgwtWidget.nativeElement.toggleCalendar();
        }
    }
    writeValue(obj) {
        if (!obj || obj instanceof Date) {
            this.value = obj;
        }
        else {
            throw new Error('The SGS datetime-picker component works with Date objects. This value is invalid: ' + obj);
        }
    }
    registerOnChange(fn) {
        this.changeListeners.push(fn);
    }
    registerOnTouched(fn) {
        this.touchListeners.push(fn);
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    // object management methods
    handleSgwtDatetimePickerReady() {
        if (!this.ready) {
            this.ready = true;
            setTimeout(() => {
                this.updateWidget();
                this.updateInputProps();
                if (this.pickerShown) {
                    this.sgwtWidget.nativeElement.toggleCalendar();
                }
            }, 0);
        }
    }
    handleSgwtDatetimePickerDatetimeUpdated() {
        this.notifyChangeListeners();
    }
    notifyChangeListeners() {
        this._dateValue = this.currentDate();
        this.changeListeners.forEach(fn => fn(this._dateValue));
    }
    notifyTouchListeners() {
        this.touchListeners.forEach(fn => fn());
        this.blur.emit(true);
    }
    updateWidget() {
        if (this.ready) {
            this.sgwtWidget.nativeElement.userSelection = this._userSelection;
            this._userSelection = {};
        }
    }
    updateInputProps() {
        if (this.ready) {
            let inputProps = this._inputProps || {};
            let onBlur = inputProps['onBlur'] ? inputProps['onBlur'] : (p) => { };
            inputProps['onBlur'] = (p) => {
                this.notifyTouchListeners();
                onBlur(p);
            };
            this.sgwtWidget.nativeElement.inputProps = inputProps;
        }
    }
    currentDate() {
        if (this.ready) {
            const momentObject = this.sgwtWidget.nativeElement.value;
            return momentObject ? momentObject.toDate() : null;
        }
        else {
            return this._dateValue;
        }
    }
    isValidDateFunctionPath() {
        return 'SGSCustom.sgsDatetimeWidget.component' + this.id + '.isValidDate';
    }
};
SgsDatetimePickerComponent.ɵfac = function SgsDatetimePickerComponent_Factory(t) { return new (t || SgsDatetimePickerComponent)(); };
SgsDatetimePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SgsDatetimePickerComponent, selectors: [["app-sgs-datetime-picker"]], viewQuery: function SgsDatetimePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sgwtWidget = _t.first);
    } }, inputs: { inputProps: ["input-props", "inputProps"], dateFormat: ["date-format", "dateFormat"], disabled: "disabled", displayDateFormat: ["display-date-format", "displayDateFormat"], displayTimeFormat: ["display-time-format", "displayTimeFormat"], keyName: ["key-name", "keyName"], isValidDate: ["is-valid-date", "isValidDate"], label: "label", returnEmpty: ["return-empty", "returnEmpty"], theme: "theme", timeFormat: ["time-format", "timeFormat"], timeConstraints: ["time-constraints", "timeConstraints"], type: "type", value: "value", locale: "locale", viewMode: ["view-mode", "viewMode"], placeholder: "placeholder", userSelection: "userSelection" }, outputs: { blur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, useExisting: SgsDatetimePickerComponent_1, multi: true }
        ])], decls: 2, vars: 0, consts: [[3, "sgwt-datetime-picker--ready", "sgwt-datetime-picker--datetime-updated"], ["sgwtWidget", ""]], template: function SgsDatetimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "sgwt-datetime-picker", 0, 1);
        ɵngcc0.ɵɵlistener("sgwt-datetime-picker--ready", function SgsDatetimePickerComponent_Template_sgwt_datetime_picker_sgwt_datetime_picker__ready_0_listener() { return ctx.handleSgwtDatetimePickerReady(); })("sgwt-datetime-picker--datetime-updated", function SgsDatetimePickerComponent_Template_sgwt_datetime_picker_sgwt_datetime_picker__datetime_updated_0_listener() { return ctx.handleSgwtDatetimePickerDatetimeUpdated(); });
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["app-sgs-datetime-picker[_ngcontent-%COMP%], sgwt-datetime-picker[_ngcontent-%COMP%]{display:inline-block}"] });
__decorate([
    ViewChild('sgwtWidget', { static: true })
], SgsDatetimePickerComponent.prototype, "sgwtWidget", void 0);
__decorate([
    Input('input-props')
], SgsDatetimePickerComponent.prototype, "inputProps", null);
__decorate([
    Input('date-format')
], SgsDatetimePickerComponent.prototype, "dateFormat", null);
__decorate([
    Input('disabled')
], SgsDatetimePickerComponent.prototype, "disabled", null);
__decorate([
    Input('display-date-format')
], SgsDatetimePickerComponent.prototype, "displayDateFormat", null);
__decorate([
    Input('display-time-format')
], SgsDatetimePickerComponent.prototype, "displayTimeFormat", null);
__decorate([
    Input('key-name')
], SgsDatetimePickerComponent.prototype, "keyName", null);
__decorate([
    Input('is-valid-date')
], SgsDatetimePickerComponent.prototype, "isValidDate", null);
__decorate([
    Input('label')
], SgsDatetimePickerComponent.prototype, "label", null);
__decorate([
    Input('return-empty')
], SgsDatetimePickerComponent.prototype, "returnEmpty", null);
__decorate([
    Input('theme')
], SgsDatetimePickerComponent.prototype, "theme", null);
__decorate([
    Input('time-format')
], SgsDatetimePickerComponent.prototype, "timeFormat", null);
__decorate([
    Input('time-constraints')
], SgsDatetimePickerComponent.prototype, "timeConstraints", null);
__decorate([
    Input('type')
], SgsDatetimePickerComponent.prototype, "type", null);
__decorate([
    Input('value')
], SgsDatetimePickerComponent.prototype, "value", null);
__decorate([
    Input('locale')
], SgsDatetimePickerComponent.prototype, "locale", null);
__decorate([
    Input('view-mode')
], SgsDatetimePickerComponent.prototype, "viewMode", null);
__decorate([
    Input('placeholder')
], SgsDatetimePickerComponent.prototype, "placeholder", null);
__decorate([
    Input('userSelection')
], SgsDatetimePickerComponent.prototype, "userSelection", null);
__decorate([
    Output('blur')
], SgsDatetimePickerComponent.prototype, "blur", void 0);

let SgsDatetimePickerModule = class SgsDatetimePickerModule {
};
SgsDatetimePickerModule.ɵfac = function SgsDatetimePickerModule_Factory(t) { return new (t || SgsDatetimePickerModule)(); };
SgsDatetimePickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SgsDatetimePickerModule });
SgsDatetimePickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule] });

class SgsCookie {
}
SgsCookie.ɵfac = function SgsCookie_Factory(t) { return new (t || SgsCookie)(); };
SgsCookie.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: SgsCookie, factory: SgsCookie.ɵfac });

let SgsEnvPropertiesService = class SgsEnvPropertiesService {
    constructor() {
        this.backend_api_name = '';
        this.backend_api_protocol = 'https';
        this.backend_api_host = '';
        this.backend_api_port = '';
        this.backend_api_basePath = 'api';
        this.backend_api_version = 'v1';
        this.sgConnect_authorization_endpoint = 'https://sgconnect-hom.fr.world.socgen/sgconnect/oauth2/authorize';
        this.sgConnect_user_info = 'https://sgconnect-hom.fr.world.socgen/sgconnect/oauth2/userinfo';
        this.sgConnect_client_id = '';
        this.sgConnect_acr_values = 'L2';
        this.sgConnect_scope = '';
        this.auth_url = '';
        this.logout_action = '';
        this.auth_type = '';
        this.environment = '';
        this.csrfCookieName = '';
        this.csrfHeaderName = '';
        this.matomo_url = '';
        this.matomo_siteId = '';
        this.accessTokenCookieName = '';
    }
};
SgsEnvPropertiesService.ɵfac = function SgsEnvPropertiesService_Factory(t) { return new (t || SgsEnvPropertiesService)(); };
SgsEnvPropertiesService.ɵprov = ɵɵdefineInjectable({ factory: function SgsEnvPropertiesService_Factory() { return new SgsEnvPropertiesService(); }, token: SgsEnvPropertiesService, providedIn: "root" });

let SgsDownloadService = class SgsDownloadService {
    constructor(cookieService, propertiesService, sgwtConnect) {
        this.cookieService = cookieService;
        this.propertiesService = propertiesService;
        this.sgwtConnect = sgwtConnect;
        this.DEFAULT_ACCESS_TOKEN_COOKIE_NAME = 'access_token';
    }
    download(endpoint, params = {}, cookies = []) {
        const url = this.configureUrl(endpoint, params);
        this.addCookies(cookies);
        window.open(url, '_blank');
        this.deleteCookies(cookies);
    }
    deleteCookies(cookies) {
        this.deleteExtraCookies(cookies);
        this.deleteAuthenticationCookie();
    }
    addCookies(cookies) {
        this.addAuthenticationCookie();
        this.addExtraCookies(cookies);
    }
    configureUrl(endpoint, params) {
        let url = endpoint;
        if (Object.getOwnPropertyNames(params).length > 0) {
            const getParams = new URLSearchParams();
            for (const p in params) {
                getParams.set(p, params[p]);
            }
            url += (url.indexOf('?') < 0 ? '?' : '&') + getParams.toString();
        }
        return url;
    }
    addAuthenticationCookie() {
        const authHeader = this.sgwtConnect.getAuthorizationHeader().split('Bearer ');
        if (authHeader.length > 1) {
            const accessTokenKey = this.getAccessTokenKey();
            const accessTokenValue = authHeader[1];
            this.cookieService.set(accessTokenKey, accessTokenValue);
        }
    }
    getAccessTokenKey() {
        return (this.propertiesService.accessTokenCookieName.trim() === '')
            ? this.DEFAULT_ACCESS_TOKEN_COOKIE_NAME : this.propertiesService.accessTokenCookieName;
    }
    deleteAuthenticationCookie() {
        const accessTokenKey = this.getAccessTokenKey();
        this.cookieService.delete(accessTokenKey);
    }
    addExtraCookies(cookies = []) {
        if (cookies.length > 0) {
            cookies.forEach(cookie => {
                this.cookieService.set(cookie.key, cookie.value);
            });
        }
    }
    deleteExtraCookies(cookies = []) {
        if (cookies.length > 0) {
            cookies.forEach(cookie => {
                this.cookieService.delete(cookie.key);
            });
        }
    }
};
SgsDownloadService.ɵfac = function SgsDownloadService_Factory(t) { return new (t || SgsDownloadService)(ɵngcc0.ɵɵinject(ɵngcc1.CookieService), ɵngcc0.ɵɵinject(SgsEnvPropertiesService), ɵngcc0.ɵɵinject(ɵngcc2.SGWTConnectCore)); };
SgsDownloadService.ctorParameters = () => [
    { type: CookieService },
    { type: SgsEnvPropertiesService },
    { type: SGWTConnectCore }
];
SgsDownloadService.ɵprov = ɵɵdefineInjectable({ factory: function SgsDownloadService_Factory() { return new SgsDownloadService(ɵɵinject(CookieService), ɵɵinject(SgsEnvPropertiesService), ɵɵinject(SGWTConnectCore$1)); }, token: SgsDownloadService, providedIn: "root" });

let SgsDownloadModule = class SgsDownloadModule {
};
SgsDownloadModule.ɵfac = function SgsDownloadModule_Factory(t) { return new (t || SgsDownloadModule)(); };
SgsDownloadModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SgsDownloadModule });
SgsDownloadModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        SgsCookie,
        SgsDownloadService
    ] });

// https://www.jvandemo.com/how-to-use-environment-variables-to-configure-your-angular-application-without-a-rebuild/
const EnvServiceFactory = () => {
    const env = new SgsEnvPropertiesService();
    const browserWindow = window || {};
    const browserWindowEnv = (browserWindow['SGSCustom'] || {})['sgsEnvProperties'] || {};
    for (const key in browserWindowEnv) {
        if (browserWindowEnv.hasOwnProperty(key)) {
            env[key] = window['SGSCustom']['sgsEnvProperties'][key];
        }
    }
    return env;
};
const EnvServiceProvider = {
    provide: SgsEnvPropertiesService,
    useFactory: EnvServiceFactory,
    deps: []
};

let SgsEnvPropertiesModule = class SgsEnvPropertiesModule {
};
SgsEnvPropertiesModule.ɵfac = function SgsEnvPropertiesModule_Factory(t) { return new (t || SgsEnvPropertiesModule)(); };
SgsEnvPropertiesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SgsEnvPropertiesModule });
SgsEnvPropertiesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        SgsEnvPropertiesService, EnvServiceProvider
    ] });

let SgsPermissionService = class SgsPermissionService {
    constructor(sgwtConnect, env) {
        this.sgwtConnect = sgwtConnect;
        this.env = env;
        this.env = env;
        const fetchUserInfoCallback = sgwtConnect.fetchUserInfo.bind(sgwtConnect);
        const fetchUserInfoAsObservable = bindCallback(fetchUserInfoCallback, (error, claims) => {
            if (error) {
                throw { error, claims };
            }
            return claims;
        });
        this.claims = fetchUserInfoAsObservable();
    }
    hasPermission(permission) {
        return this.claims.pipe(mergeMap(x => x.user_authorization), filter(a => a['resource'] !== this.env.backend_api_name), mergeMap(x => x.permissions), pluck('name'), filter(p => p === permission), isEmpty(), map(x => !x), take(1));
    }
    hasPermissions() {
        return this.claims.pipe(mergeMap(x => x.user_authorization), tap(x => console.log('user_authorization:' + x)), filter(a => a['resource'] !== this.env.backend_api_name), mergeMap(x => x.permissions), pluck('name'), isEmpty(), map(x => !x), take(1));
    }
};
SgsPermissionService.ɵfac = function SgsPermissionService_Factory(t) { return new (t || SgsPermissionService)(ɵngcc0.ɵɵinject(ɵngcc3.SGWTConnectCore), ɵngcc0.ɵɵinject(SgsEnvPropertiesService)); };
SgsPermissionService.ctorParameters = () => [
    { type: SGWTConnectCore$2 },
    { type: SgsEnvPropertiesService }
];
SgsPermissionService.ɵprov = ɵɵdefineInjectable({ factory: function SgsPermissionService_Factory() { return new SgsPermissionService(ɵɵinject(SGWTConnectCore$1), ɵɵinject(SgsEnvPropertiesService)); }, token: SgsPermissionService, providedIn: "root" });

let SgsPermissionModule = class SgsPermissionModule {
};
SgsPermissionModule.ɵfac = function SgsPermissionModule_Factory(t) { return new (t || SgsPermissionModule)(); };
SgsPermissionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SgsPermissionModule });
SgsPermissionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        SgsPermissionService
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsDatetimePickerComponent, [{
        type: Component,
        args: [{ selector: 'app-sgs-datetime-picker', template: "<sgwt-datetime-picker\r\n  #sgwtWidget\r\n  (sgwt-datetime-picker--ready)=\"handleSgwtDatetimePickerReady()\"\r\n  (sgwt-datetime-picker--datetime-updated)=\"handleSgwtDatetimePickerDatetimeUpdated()\"\r\n></sgwt-datetime-picker>\r\n", providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: SgsDatetimePickerComponent_1, multi: true }
                ], styles: ["app-sgs-datetime-picker,sgwt-datetime-picker{display:inline-block}"] }]
    }], function () { return []; }, { blur: [{
            type: Output,
            args: ['blur']
        }], inputProps: [{
            type: Input,
            args: ['input-props']
        }], dateFormat: [{
            type: Input,
            args: ['date-format']
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }], displayDateFormat: [{
            type: Input,
            args: ['display-date-format']
        }], displayTimeFormat: [{
            type: Input,
            args: ['display-time-format']
        }], keyName: [{
            type: Input,
            args: ['key-name']
        }], isValidDate: [{
            type: Input,
            args: ['is-valid-date']
        }], label: [{
            type: Input,
            args: ['label']
        }], returnEmpty: [{
            type: Input,
            args: ['return-empty']
        }], theme: [{
            type: Input,
            args: ['theme']
        }], timeFormat: [{
            type: Input,
            args: ['time-format']
        }], timeConstraints: [{
            type: Input,
            args: ['time-constraints']
        }], type: [{
            type: Input,
            args: ['type']
        }], value: [{
            type: Input,
            args: ['value']
        }], locale: [{
            type: Input,
            args: ['locale']
        }], viewMode: [{
            type: Input,
            args: ['view-mode']
        }], placeholder: [{
            type: Input,
            args: ['placeholder']
        }], userSelection: [{
            type: Input,
            args: ['userSelection']
        }], sgwtWidget: [{
            type: ViewChild,
            args: ['sgwtWidget', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsDatetimePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [SgsDatetimePickerComponent],
                imports: [
                    CommonModule,
                    FormsModule
                ],
                exports: [
                    SgsDatetimePickerComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SgsDatetimePickerModule, { declarations: function () { return [SgsDatetimePickerComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [SgsDatetimePickerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsEnvPropertiesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsDownloadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.CookieService }, { type: SgsEnvPropertiesService }, { type: ɵngcc2.SGWTConnectCore }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsDownloadModule, [{
        type: NgModule,
        args: [{
                providers: [
                    SgsCookie,
                    SgsDownloadService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsEnvPropertiesModule, [{
        type: NgModule,
        args: [{
                providers: [
                    SgsEnvPropertiesService, EnvServiceProvider
                ]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsPermissionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.SGWTConnectCore }, { type: SgsEnvPropertiesService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SgsPermissionModule, [{
        type: NgModule,
        args: [{
                providers: [
                    SgsPermissionService
                ]
            }]
    }], null, null); })();


/**
 * Generated bundle index. Do not edit.
 */

export { EnvServiceProvider, SgsCookie, SgsDatetimePickerModule, SgsDownloadModule, SgsDownloadService, SgsEnvPropertiesModule, SgsEnvPropertiesService, SgsPermissionModule, SgsPermissionService, EnvServiceFactory as ɵa, SgsDatetimePickerComponent as ɵb };

